export type StoreRoute =
  | { kind: 'home' }
  | { kind: 'launch' }
  | { kind: 'store'; storeId: string }
  | { kind: 'not-found' };

const STORE_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{1,31}$/;

export function parseStoreRoute(pathname: string): StoreRoute {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (normalizedPath === '/') return { kind: 'home' };
  if (normalizedPath === '/launch') return { kind: 'launch' };

  const match = normalizedPath.match(/^\/store\/([^/]+)$/);
  if (!match) return { kind: 'not-found' };

  try {
    const storeId = decodeURIComponent(match[1]);
    return STORE_ID_PATTERN.test(storeId)
      ? { kind: 'store', storeId }
      : { kind: 'not-found' };
  } catch {
    return { kind: 'not-found' };
  }
}

export function storePath(storeId: string): string {
  return `/store/${encodeURIComponent(storeId)}`;
}
